import React from 'react'

const SvgDocument = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M25 12v12.993A1 1 0 0124.007 26H7.993A.993.993 0 017 25.008V6.992C7 6.455 7.449 6 8.002 6h10.995L25 12zm-2 1h-5V8H9v16h14V13z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgDocument
